__turbopack_context__.v({
  "block": "DataBlock-module-scss-module___7ZJgq__block",
});
